import { Component, OnDestroy } from '@angular/core';
import { ContentService } from '../../services/content/content.service';
import { UtilService } from '../../services/util/util.service';
import { Subscription } from 'rxjs';
import { ProfileStorageService } from '../../services/profile/profile-storage.service';
import { PrismicService } from '../../services/prismic/prismic.service';
import { InViewType } from '../../components/in-view/in-view.model';
import { CTA, HomeContent } from './home-page.cms.model';
import {PrismicHomePage} from "../../../types/app-types";

const content = require('./home-page.content.json');

@Component({
  selector: 'app-home',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnDestroy {
  public isMobile: boolean;
  public subscriptions: Subscription[] = [];
  public isLoggedIn: boolean = false;
  public landschapType: InViewType = InViewType.LANDSCHAP;
  public cmsContent: HomeContent;

  public constructor(
    private contentService: ContentService,
    private utilService: UtilService,
    private profileStorageService: ProfileStorageService,
    private prismic: PrismicService
  ) {
    this.contentService.loadContent(content);
    this.subscriptions.push(
      profileStorageService.loggedInSubject.subscribe(isLoggedIn => (this.isLoggedIn = isLoggedIn))
    );
    this.subscriptions.push(
      utilService.getScreenMode$().subscribe(screenMode => {
        this.isMobile = screenMode.includes('MOBILE');
      })
    );
    prismic.getDocumentByType<PrismicHomePage>('homepage').then(doc => {
      this.cmsContent = new HomeContent(this.prismic, doc.data);
    });
  }

  public activeCtas(): CTA[] {
    return this.cmsContent.ctas.filter(cta => cta.active === true);
  }


  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
